import React, { Component } from "react";

export default class Settings extends Component {
  render() {
    return <div>Settings</div>;
  }
}



// WEBPACK FOOTER //
// ./src/_components/Profile/Settings/index.js